const createEventLogApi = ({ eventLog, eventLogAtom }) => ({
  eventLog: {
    record: eventLog.record,
    remove: eventLog.remove,
    exportFormatted: eventLog.exportFormatted,
    clear: () => eventLogAtom.set(undefined),
    getVersionHistory: eventLog.getVersionHistory,
    isEmpty: eventLog.isEmpty,
  },
})

// eslint-disable-next-line @exodus/export-default/named
export default {
  id: 'eventLogApi',
  type: 'api',
  factory: createEventLogApi,
  dependencies: ['eventLog', 'eventLogAtom'],
}
